import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grow from '@mui/material/Grow'

import { observer } from 'mobx-react-lite'

import { CheckCircle } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../common'

export interface FeedbackBarProps {
  show: boolean
  onTellUsMore: () => void
}

/** Confirmation bar shown after rating an insight. */
export const FeedbackBar = observer(({ show, onTellUsMore }: FeedbackBarProps) => {
  const copy = useGlobalCopyStore().insights_feed?.feedback_bar

  if (!copy) return null

  return (
    <Grow appear in={show} unmountOnExit>
      <Box sx={{ pb: 16, px: 16 }}>
        <Alert
          action={
            <Button
              aria-label={copy.tell_us_more}
              color="inherit"
              onClick={onTellUsMore}
              sx={{
                color: 'common.white',
                fontWeight: 600,
                lineHeight: '20px',
                ':hover': { bgcolor: 'grey.600' },
              }}
            >
              {copy.tell_us_more}
            </Button>
          }
          icon={<CheckCircle filled sx={{ color: 'success.light' }} />}
          severity="success"
          sx={{
            alignItems: 'center',
            bgcolor: 'grey.700',
            border: 'none',
            display: 'flex',
            height: 56,
            justifyContent: 'space-between',
            '& .MuiAlert-action': { height: 44 },
          }}
        >
          <Text aria-live="assertive" color="white" sx={{ lineHeight: '20px' }} truncate={false}>
            {copy.feedback_sent}
          </Text>
        </Alert>
      </Box>
    </Grow>
  )
})

export default FeedbackBar
